import script from "./PDFViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFViewer.vue?vue&type=script&setup=true&lang=js"

import "./PDFViewer.vue?vue&type=style&index=0&id=44563bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44563bda"]])

export default __exports__